'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

function getVisitorId(): string {
  const key = 'brief_vid';
  let vid = localStorage.getItem(key);
  if (!vid) {
    vid = crypto.randomUUID();
    localStorage.setItem(key, vid);
  }
  return vid;
}

export default function AnalyticsTracker() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname === '/analytics') return;

    const trackPageView = async () => {
      try {
        const vid = getVisitorId();
        await fetch('/api/analytics/track', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            path: pathname,
            referrer: document.referrer,
            user_agent: navigator.userAgent,
            visitor_id: vid,
            screen: `${screen.width}x${screen.height}`,
            language: navigator.language,
          }),
        });
      } catch (error) {
        // silent fail
      }
    };

    trackPageView();
  }, [pathname]);

  return null;
}
